<template>
    <div @click="closeModal()" class="product-modal">
        <div v-on:click.stop class="product-modal-container no-scrollbar">
            <div class="main-container">
                <div class="second-container mobile">
                    <div class="info-container">
                        <p v-if="!isSelected && !canAdd" class="oops">Oops!</p>
                        <p v-if="title" class="main-title">{{ title }}</p>
                        <p class="product-title">{{ product.title }}</p>
                        <div v-if="maxQty > 1" class="box-qty-input-container">
                            <button :disabled="selectedQty < 2" @click="incrementBoxQty(false)">-</button> 
                            <input :disabled="true" v-model="selectedQty" type="number" min="1"> 
                            <button :disabled="selectedQty == maxQty" @click="incrementBoxQty(true)">+</button> 
                        </div>
                    </div>
                </div>
                <div class="first-container">
                    <div class="image-container desktop">
                        <img :src="currentMainImage" class="main-image">
                        <div v-if="product.images.length > 1" class="extra-images-container">
                            <img 
                                v-for="image in product.images" 
                                :key="image.id"
                                class="extra-image"
                                :class="image.src == currentMainImage ? 'selected' : ''"
                                :src="image.src"
                                @click="selectImage(image.src)"
                            >
                        </div>
                    </div>
                </div>
                <div class="second-container">
                    <div class="info-container">
                        <p v-if="!isSelected && !canAdd" class="oops desktop">Oops!</p>
                        <p v-if="title" class="main-title desktop">{{ title }}</p>
                        <p class="product-title desktop">{{ product.title }}</p>
                        <p class="variant-text" :class="showAlert ? 'red' : ''"  v-if="variantOptions.length > 1">Please select your model</p>
                        <div v-if="variantOptions.length > 1">
                            <select v-model="selectedVariant" id="variantSelector">
                                <option v-for="variant in variantOptions" :key="variant.id" :value="variant">{{variant.title}}</option>
                            </select>
                        </div>
                        <div v-if="maxQty > 1" class="box-qty-input-container desktop-flex">
                            <button :disabled="selectedQty < 2" @click="incrementBoxQty(false)">-</button> 
                            <input :disabled="true" v-model="selectedQty" type="number" min="1"> 
                            <button :disabled="selectedQty == maxQty" @click="incrementBoxQty(true)">+</button> 
                        </div>
                        <p v-html="description" class="main-description"></p>
                    </div>
                    <div class="buttons-container">
                        <button v-if="maxQty > 1 && isSelected && availableCapacity > 0 && cartDiff == 0" @click="closeModal()" class="happybox-button green border" >Add More Gifts</button>
                        <button v-if="maxQty > 1 && cartDiff != 0 && isSelected && canAdd" @click="selectProduct()" class="happybox-button green border">Update gift quantity</button>
                        <button v-if="maxQty > 1 && cartDiff != 0 && isSelected && !canAdd" @click="cleanAdd()" class="happybox-button green border">Clean cart and update gift</button>
                        <button v-if="(isSelected && !isBundle) || (isSelected && isBundle && bundleRemaining == 0 && tabCapacity == 0)" @click="checkout" :class="[isLoading ? 'isLoading' : '',(availableCapacity != 0 || (maxQty > 1 && cartDiff != 0 && isSelected)) ? 'gray' : 'green']" :disabled="availableCapacity != 0 || (maxQty > 1 && cartDiff != 0 && isSelected)" class="happybox-button border">Next Step: Add your Address</button>
                        <button v-else-if="isSelected && isBundle && bundleRemaining > 0 && tabCapacity == 0" @click="nextStep"  class="happybox-button green border">Next Step</button>
                        <button v-else-if="isSelected && isBundle && bundleRemaining > 0 && tabCapacity > 0" @click="closeModal()"  class="happybox-button green border">Pick next gift</button>
                        <button v-else-if="canAdd" @click="selectProduct()" class="happybox-button green border">Add this gift</button>
                        <button v-else @click="cleanAdd()" class="happybox-button green border">Replace with this gift</button>
                    </div>
                </div>
                <img @click="closeModal()" class="close"  src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            selectedImage: null,
            selectedQty: 1,
            selectedVariant: null,
            propertiesSelected: [],
            showAlert: false,
        }
    },
    components:{
    },
    props:{
        product: Object,
        cartProducts: Array,
        availableCapacity: Number,
        isLoading: Boolean,
        collectionValue: Number,
        isBundle: Boolean,
        tabs: Array,
    },
    computed:{
        isSelected(){
            return this.cartProducts.find(x => x.id == this.product.id)
        },
        productCapacity(){
            let tags = this.product.tags;
            let value = tags.find(y => y.toLowerCase().includes("goc_capacity_"))
            if(value){
              value = value.split("_")[2];

              return parseInt(value);
            }

            return 0
        },
        variantOptions(){
           return this.product.variants.filter(x => x.inventory_quantity > 0);
        },
        extraProperties(){
            if(this.product.tags.includes("Properties_")){
                let tags = this.product.tags;
                let propertiesTags = tags.filter(x => x.includes("Properties_"));

                return propertiesTags.map((x) => {
                    let splittedTag = x.split("_");
                    let values = splittedTag[splittedTag.length - 1].split("-");

                    return {name: splittedTag[1],values: values}
                })
            }

            return []
        },
        canAdd(){ 
            if(this.isBundle)
                return (this.selectedQty - this.cartQty) <= this.tabs[this.product.tab].currentQty
            else
                return (this.productCapacity * (this.selectedQty - this.cartQty)) <= this.availableCapacity
        },
        cartQty(){
            if(this.isSelected && this.isSelected.qty){
                return this.isSelected.qty;
            }

            return 0
        },
        cartDiff(){
            return this.cartQty - this.selectedQty;
        },
        maxQty(){
            if(this.isBundle)
                return this.tabs[this.product.tab].maxQty
            else
                return Math.floor(this.collectionValue / this.productCapacity)
        },
        title(){
            if(this.isSelected && this.maxQty == 1){
                return "Great Choice!"
            }
            else{
                if(this.canAdd){
                    return null
                }
                else {
                    return "This gift surpasses the value limit"
                }
            }
        },
        subtitle(){
            if(!this.isSelected && !this.canAdd){
                return "Would you like to empty cart and add only this gift?"
            }

            return null;
        },
        description(){
            if(this.product)
                return this.product.body_html;
            
            return '';
        },
        currentMainImage(){
            if(this.selectedImage){
                return this.selectedImage;
            }
            else {
               return this.product.images[0].src
            }
        },
        currentMainImageIndex(){
            if(this.selectedImage){
                let index = this.product.images.findIndex(x => x.src == this.selectedImage)
                if(index > -1)
                    return index
            }

            return 0
        },
        tabCapacity(){
            if(this.isBundle){
                return this.tabs[this.product.tab].currentQty;
            }

            return 0
        },
        bundleRemaining(){
            return this.tabs.reduce((prev, current) => prev + current.currentQty,0)
        }
    },
    methods:{
        closeModal(){
            this.$emit("closemodal");
        },
        selectProduct(){
            if((!this.canAdd  || this.isSelected) && this.cartDiff == 0)
                return
            if(this.variantOptions.length > 1 && !this.selectedVariant){
                this.showAlert = true;
                return
            }
            let productToSend = JSON.parse(JSON.stringify(this.product));
            productToSend.qty = this.selectedQty;
            if(this.variantOptions.length > 1){
                productToSend.variants = [this.selectedVariant];
            }
            this.$emit("selectproduct",productToSend);
        },
        cleanAdd(){
            if((!this.canAdd  || this.isSelected) && this.cartDiff == 0)
                return
            if(this.variantOptions.length > 1 && !this.selectedVariant){
                this.showAlert = true;
                return
            }
            let productToSend = JSON.parse(JSON.stringify(this.product));
            productToSend.qty = this.selectedQty;
            if(this.variantOptions.length > 1){
                productToSend.variants = [this.selectedVariant];
            }
            this.$emit("cleanadd",productToSend);
        },
        checkout(){
            this.$emit("checkout")
        },
        selectImage(src){
            this.selectedImage = src;
        },
        incrementBoxQty(increment){
            if(increment){
                this.selectedQty++
            }
            else {
                if(this.selectedQty > 1){
                    this.selectedQty--;
                }
            }
        },
        nextStep(){
            this.$emit("nextstep");
            this.$emit("closemodal");
        }
    },
    mounted(){
        let selected = this.cartProducts.find(x => x.id == this.product.id);
        if(selected && selected.qty){
            this.selectedQty = selected.qty;
        }
    }
}
</script>

<style scoped>
.product-modal{
    background-color: #0000001F!important;
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding: 45px 0;
 }

 .product-modal-container{
    width: 60%;
    border-radius: 20px;
    max-height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    overflow-y: scroll;
    box-shadow: 0px 0px 0px 1px #0000001f;
 }

 .product-modal-container .main-container{
    padding: 5%;
    width: 100%;
    display: flex;
    justify-content: space-between;
 }

 .product-modal-container .main-container .oops{
    font-size: 2vw;
    font-weight: bold;
    font-style: italic;
 }

 .product-modal-container .main-container .main-title{
    font-size: 1.3vw;
    line-height: 1.2;
    font-weight: 700;
    text-transform: uppercase;
    color: #5a3089;
    margin-bottom: 3%;
 }

 .product-modal-container .main-container .subtitle{
    font-size: 1.5vw;
    text-align: center;
    margin-bottom: 5%;
 }

 .product-modal-container .main-container .first-container,.product-modal-container .main-container .second-container{
    width: 48%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
 }

 .image-container{
    width: 100%;
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
 }

 .image-container .main-image{
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    background-color: #f6f6f6;
 }

 .product-modal .close{
    position: absolute;
    float: unset;
    top: 2%;
    right: 2%;
    width: 2vw;
    line-height: 1;
 }

 .product-modal .product-title{
    font-size: 2vw;
    color: #0f0c38;
    font-weight: 700;
    line-height: 1;
 }

 .product-modal .main-description{
    margin: 5% 0%;
    background-color: #f6f6f6;
    padding: 10px;
    font-size: 1vw;
    color: #0f0c38;
    max-height: 80%;
    overflow-y: auto;
    width: 100%;
 }

 .product-modal .buttons-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
 }

 .product-modal .buttons-container button{
    width: 100%;
 }

    .extra-images-container{
        width: 100%;
        display: flex;
        gap: 10px;
    }

    .extra-image{
        width: 15%;
        max-width: 30%;
        flex: 1;
        background-color: #f6f6f6;
        cursor: pointer;
    }

    .extra-image.selected{
        border: 1px solid black;
    }

    .box-qty-input-container{
        width: 50%;
        display: flex;
        justify-content: flex-start;
        margin-top: 2%;
    }

    .box-qty-input-container input{
        background-color: #fff;
        border: 1px solid #e4e4e7 !important;
        border-radius: 4px !important;
        height: unset !important;
        padding: 1% 2% !important;
        text-align: center;
        font-size: 1.3vw;
        width: 40% !important;
        line-height: 1.5;
        -moz-appearance: textfield;
        color: #0f0c38;
    }

    .box-qty-input-container button{
        background-color: #fff;
        border: 1px solid #e4e4e7;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2vw;
        padding: 0 4%;
        line-height: 1;
        margin: 0 2%;
        color: #0f0c38;
        min-width: 25px;
    }

    .box-qty-input-container button:hover{
        background-color:#faf7fe
    }
    .box-qty-input-container button:disabled{
        opacity:.6
    }

    .box-qty-input-container input::-webkit-inner-spin-button,
    .box-qty-input-container input::-webkit-outer-spin-button{
        -webkit-appearance:none;
        margin:0
    }

    .variant-text{
        margin-top: 1rem;
        font-size: 1.15vw;
    }

    .variant-text.red{
        color: red;
    }

    #variantSelector{
        width: 100%;
        border-radius: 4px;
        height: 2rem;
        box-shadow: 0px 0px 2px 0px;
    }

 @media only screen and (max-device-width: 767px){
    .product-modal-container{
        width: 85%;
        height: auto;
        max-height: 100%;
    }

    .product-modal-container .main-container{
        flex-direction: column;
        padding: 10% 5%;
    }

    .product-modal-container .main-container .first-container, .product-modal-container .main-container .second-container{
        width: 100%;
    }

    .product-modal .purple-link{
        font-size: 3vw
    }

    .product-modal-container .main-container .subtitle{
        font-size: 3.5vw;
        text-align: center;
    }

    .product-modal .product-title{
        font-size: 6vw;
        text-align: center;
        margin-bottom: 5%;
    }

    .product-modal-container .main-container .main-title{
        text-align: center;
        font-size: 4vw;
        margin-bottom: 5%;
    }

    .product-modal-container .main-container .oops{
        font-size: 4.5vw;
        text-align: center;
    }

    .product-modal .main-description{
        font-size: 3vw;
    }

    .product-modal .main-description > p,.product-modal .main-description > span{
        max-height: 15vh;
        display: block;
    }

    .product-modal-container .main-container .second-container{
        flex-direction: column-reverse;
        margin-top: 5%;
    }

    .box-qty-input-container{
        justify-content: center;
        width: 100%;
        margin-bottom: 5%;
    }

    .box-qty-input-container input{
        font-size:4.5vw;
        width:20%!important
    }

    .box-qty-input-container button{
        font-size:5vw;
        padding:0 8%;
        line-height:1.3
    }

    .product-modal .close{
        width: 5vw;
        right: 5%;
    }

    .product-modal .buttons-container button{
        padding: 2%;
    }

    .happybox-button.green:hover{
        background-color: #5cffc0;
    }

    .variant-text{
        font-size: 3.5vw;
    }
 }


</style>